import { listen, isLogoutMessage, isData } from "@sinch/bus";
import { useEffect } from "react";

export const useLogoutHandler = (
  logout: (redirect?: string | null) => void
) => {
  useEffect(() => {
    const unsub = listen((m) => {
      if (isData(m)) {
        logout(m.payload?.redirect || null);
      }
    }, isLogoutMessage);

    return unsub;
  }, [logout]);
};
